import {FormControl} from '@primer/react'
import {Dialog} from '@primer/react/experimental'
import React, {type FormEvent, lazy, useState} from 'react'
import {AlertIcon} from '@primer/octicons-react'
import {isValidJSONSchema} from './json-schema-utils'

const CodeMirror = lazy(() => import('@github-ui/code-mirror'))

export function JsonSchemaDialog({
  onClose,
  onSubmit,
  jsonSchema,
}: {
  onClose: () => void
  onSubmit: (input: string) => void
  jsonSchema?: string
}) {
  const [isValidJSON, setIsValidJSON] = useState(true)
  const [jsonInput, setJsonInput] = useState(jsonSchema || '')

  const validateForm = async (event: FormEvent) => {
    event.preventDefault()

    if (!isValidJSONSchema(jsonInput)) {
      setIsValidJSON(false)
      return
    }

    onSubmit(jsonInput)
  }

  const handleChange = (input: string) => {
    setJsonInput(input)
  }

  return (
    <Dialog
      title="Enter JSON Schema"
      subtitle="Use a JSON schema to define the structure of the model's response format."
      width="xlarge"
      onClose={onClose}
      footerButtons={[
        {
          buttonType: 'default',
          content: 'Cancel',
          onClick: onClose,
          form: 'json-schema-form',
        },
        {
          buttonType: 'primary',
          content: 'Save',
          onClick: validateForm,
          form: 'json-schema-form',
        },
      ]}
    >
      <span className="color-fg-danger">
        {!isValidJSON && (
          <>
            <AlertIcon aria-hidden /> Invalid JSON or value
          </>
        )}
      </span>
      <FormControl>
        <FormControl.Label>Definition</FormControl.Label>
        <React.Suspense fallback={<></>}>
          <CodeMirror
            fileName="document.json"
            value={jsonSchema}
            ariaLabelledBy="json-schema-code-label"
            height="100%"
            spacing={{
              indentUnit: 2,
              indentWithTabs: false,
              lineWrapping: true,
            }}
            hideHelpUntilFocus
            onChange={handleChange}
            isReadOnly={false}
          />
        </React.Suspense>
      </FormControl>
    </Dialog>
  )
}

try{ CodeMirror.displayName ||= 'CodeMirror' } catch {}
try{ JsonSchemaDialog.displayName ||= 'JsonSchemaDialog' } catch {}